Controller.$inject = [];

function Controller() {

}

export function HuiModalBody() {
    return {
        restrict: 'E',
        replace: true,
        scope: true,
        controller: Controller,
        controllerAs: '$huiCtrl',
        transclude: true,
        template: ($element, $attrs) => {
            return `<div class="modal-body" ng-transclude></div>`;
        }
    }
}